import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CONSTANTS, getUtility, Icon, toast } from '@livable/saas-react-components';
import { Button, Chip, Menu, Typography } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { skipReasonTypes, billStatuses, ALLOCATION_METHOD } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import useStyles from './styles';
const Utility = props => {
  var _store$files$fileData, _statuses$TableReadyS, _statuses$billStatus, _statuses$billStatus2;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const allocationCycleId = props.allocationCycleId,
    billingCycleId = props.billingCycleId,
    buildingAddress = props.buildingAddress,
    cycleName = props.cycleName,
    disabled = props.disabled,
    isAdditional = props.isAdditional,
    isCurrent = props.isCurrent,
    property = props.property,
    _props$propertyId = props.propertyId,
    propertyId = _props$propertyId === void 0 ? null : _props$propertyId,
    submeterAllocated = props.submeterAllocated,
    utility = props.utility;
  const currentCompany = store.homeDashboardStore.getCurrentCompany;
  const allocated = utility.allocated,
    billAmount = utility.billAmount,
    billEndDateOnly = utility.billEndDateOnly,
    billStartDateOnly = utility.billStartDateOnly,
    billStatus = utility.billStatus,
    deductions = utility.deductions,
    fileId = utility.fileId,
    redactedFileId = utility.redactedFileId,
    isSkipped = utility.isSkipped,
    utilityId = utility.utilityId;
  const billingTab = (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.billingTab) || {};
  const fileName = (_store$files$fileData = store.files.fileDataById.get(redactedFileId ? redactedFileId : fileId)) === null || _store$files$fileData === void 0 ? void 0 : _store$files$fileData.fileName;
  const isPending = billStatus === 'PendingCompletion';
  const setApplyBill = billingTab.setApplyBill;
  const setIsOpen = billingTab.setIsApplyBillingIsOpen;
  const setSubmeterBillModalOpenState = billingTab.setSubmeterBillModalOpenState;
  const setSubmeterBill = billingTab.setSubmeterBill;
  const statuses = billStatuses(t);
  const utilityProviderData = store.utilityProviders.utilities.get(utilityId);
  const utilityData = getUtility(utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.utilityTypeName);
  const utilityDataFromProviders = store.properties.propertyUtilities.find(u => u.utilityId === utilityId) || {};
  const allocationMethod = CONSTANTS.ALLOCATION_METHODS[utilityDataFromProviders.allocationMethod];
  const isBySubmeter = utilityDataFromProviders.allocationMethod === ALLOCATION_METHOD.BySubmeter && !store.account.featureFlagsStore.getEnableSubmeterBilling;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const deleteBillingCycle = async data => {
    const resp = await store.allocations.deleteBillingCycleAsync.run(data);
    return resp;
  };
  const postTableApproval = async data => {
    const resp = await store.allocations.postTableApprovalAsync.run(data);
    return resp;
  };
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleProcess = async () => {
    if (isBySubmeter) {
      var _ref, _property$propertyInf;
      await store.homeDashboardStore.getCurrentCompany.fetchBuildingInformation({
        propertyId: propertyId,
        portfolioId: 'all'
      });
      await setSubmeterBill({
        allocationCycleId,
        allocationMethod,
        billingCycleId,
        buildingAddress: (_ref = buildingAddress !== null && buildingAddress !== void 0 ? buildingAddress : (_property$propertyInf = property.propertyInformation) === null || _property$propertyInf === void 0 || (_property$propertyInf = _property$propertyInf.address) === null || _property$propertyInf === void 0 ? void 0 : _property$propertyInf.addressString) !== null && _ref !== void 0 ? _ref : property.dashboard.propertyAddress,
        cycleName,
        propertyId,
        status: billStatus,
        utilityId,
        utilityName: utilityData.title
      });
      setSubmeterBillModalOpenState(true);
      return;
    }
    setApplyBill({
      allocationCycleId,
      allocationMethod,
      billingCycleId,
      buildingAddress,
      commonAreaDeduction: utilityDataFromProviders.commonAreaDeduction,
      cycleName,
      goodWillDeduction: isPending ? utilityDataFromProviders.goodWillDeduction : null,
      propertyId,
      // Carried through so the Process modal can match a portal credential to this exact utility.
      // The allocation payload has only the generic utilityId; propertyUtilityId is the key a
      // credential is stored against, and it is already resolved on this row above.
      propertyUtilityId: utilityDataFromProviders.propertyUtilityId,
      status: billStatus,
      utilityId,
      utilityName: utilityData.title
    });
    setIsOpen(true);
  };
  const handleSkip = async () => {
    handleClose();
    if (isSkipped) postTableApproval({
      additionalSkipComment: null,
      allocationTableSkipReason: null,
      allocationCycleId,
      billingCycleId,
      isApproved: null,
      isSkipped: false,
      otherSkipReason: null,
      propertyId,
      utilityId
    }).then(() => billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _store$homeDashboardS;
      return billingTab.addToPreviewQueue({
        billingCycleId,
        id: billingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
        propertyId
      });
    }).then(() => toast('success', {
      body: ['Bill unskipped successfully']
    })).catch(() => toast('error', ['Error in skipping bill']));else {
      billingTab.setSkipModal({
        allocationCycleId,
        billingCycleId,
        buildingAddress,
        cycleName,
        isEdit: false,
        propertyId,
        utilityId,
        utilityName: utilityData.title
      });
      billingTab.setSkipModalOpen(true);
    }
  };
  const handleDelete = async () => {
    handleClose();
    deleteBillingCycle({
      billingCycleId,
      propertyId
    }).then(() => currentCompany.billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _property$allocations;
      return property === null || property === void 0 || (_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.deleteCycle(billingCycleId);
    }).then(() => {
      var _property$allocations2;
      return property === null || property === void 0 || (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 ? void 0 : _property$allocations2.removeIdFromBillingCycleIds(billingCycleId);
    }).then(() => toast('success', {
      body: ['Bill deleted successfully']
    })).catch(() => toast('error', ['Error deleting bill']));
  };
  const handleEdit = async () => {
    if (isBySubmeter) {
      if (utility.submeterFinalState !== null && Array.isArray(utility.submeterFinalState) && utility.submeterFinalState.length > 0) {
        var _ref2, _property$propertyInf2;
        await store.homeDashboardStore.getCurrentCompany.fetchBuildingInformation({
          propertyId: propertyId,
          portfolioId: 'all'
        });
        await setSubmeterBill({
          allocationCycleId,
          allocationMethod,
          billingCycleId,
          buildingAddress: (_ref2 = buildingAddress !== null && buildingAddress !== void 0 ? buildingAddress : (_property$propertyInf2 = property.propertyInformation) === null || _property$propertyInf2 === void 0 || (_property$propertyInf2 = _property$propertyInf2.address) === null || _property$propertyInf2 === void 0 ? void 0 : _property$propertyInf2.addressString) !== null && _ref2 !== void 0 ? _ref2 : property.dashboard.propertyAddress,
          cycleName,
          propertyId,
          status: 'TableReadyStatementSent',
          //billStatus,
          utilityId,
          utilityName: utilityData.title
        });
        setSubmeterBillModalOpenState(true);
        return;
      }
    }
    billingTab.setSkipModal({
      additionalSkipComment: utility.additionalSkipComment,
      allocationTableSkipReason: utility.allocationTableSkipReason,
      allocationCycleId,
      billingCycleId,
      buildingAddress,
      cycleName,
      isEdit: true,
      isFromHistory: !isCurrent,
      otherSkipReason: utility.otherSkipReason,
      propertyId,
      utilityId,
      utilityName: utilityData.title
    });
    billingTab.setSkipModalOpen(true);
  };
  const formattedServiceDates = billStartDateOnly && billEndDateOnly ? moment(billStartDateOnly).format('MM/DD/YYYY') + ' - ' + moment(billEndDateOnly).format('MM/DD/YYYY') : null;
  const getAllocationMethod = () => allocationMethod ? /*#__PURE__*/React.createElement(React.Fragment, null, t('allocations.allocated_by'), " ", /*#__PURE__*/React.createElement("b", null, allocationMethod)) : null;
  const getServiceDates = () => billStartDateOnly && billEndDateOnly ? /*#__PURE__*/React.createElement(React.Fragment, null, t('resident_account.service_dates'), " ", /*#__PURE__*/React.createElement("b", null, formattedServiceDates)) : null;
  const getStatus = () => billStatus === 'TableReadyStatementSent' ? 'Review' : 'Preview';
  const getButton = (label, amount, customAttribute) => label === 'Deductions' ? !!amount || amount === 0 ? /*#__PURE__*/React.createElement(Button, {
    'custom-attribute': customAttribute,
    className: classes.billAmount,
    onClick: handleProcess,
    size: "small",
    variant: "actionIcon"
  }, /*#__PURE__*/React.createElement("span", null, label, ": "), amount, "%") : null : amount ? /*#__PURE__*/React.createElement(Button, {
    'custom-attribute': customAttribute,
    className: classes.billAmount,
    onClick: handleProcess,
    size: "small",
    variant: "actionIcon"
  }, /*#__PURE__*/React.createElement("span", null, label, ": "), Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency'
  }).format(amount)) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionBodyItemInfoIcon, " ").concat(disabled ? classes.disabled : '')
  }, utilityData.icon()), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetailsTitle
  }, /*#__PURE__*/React.createElement("b", {
    className: disabled ? classes.disabled : ''
  }, utilityData.title), !utility.isDefaultBillingCycle && (isCurrent || utility.isHistoricalAllocationCycle) ? /*#__PURE__*/React.createElement(Typography, {
    color: "light",
    padding: "2px",
    variant: "h6"
  }, "(Additional)") : null, /*#__PURE__*/React.createElement(Chip, {
    label: isBySubmeter && utility.submeterFinalState !== null && Array.isArray(utility.submeterFinalState) && utility.submeterFinalState.length > 0 ? (_statuses$TableReadyS = statuses.TableReadyStatementSent) === null || _statuses$TableReadyS === void 0 ? void 0 : _statuses$TableReadyS.label : utility.allocationTableSkipReason && utility.billStatus === 'TableSkipped' ? skipReasonTypes(t)[utility.allocationTableSkipReason] : (_statuses$billStatus = statuses[billStatus]) === null || _statuses$billStatus === void 0 ? void 0 : _statuses$billStatus.label,
    variant: disabled ? 'inactive' : (_statuses$billStatus2 = statuses[billStatus]) === null || _statuses$billStatus2 === void 0 ? void 0 : _statuses$billStatus2.variant
  }), fileName ? /*#__PURE__*/React.createElement("div", {
    className: classes.fileNameIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "attachment-clip",
    viewBox: "0 0 13 14"
  })) : null), /*#__PURE__*/React.createElement("i", null, utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.providerName), /*#__PURE__*/React.createElement("i", null, getAllocationMethod()), /*#__PURE__*/React.createElement("i", null, getServiceDates()))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemControl
  }, getButton('Allocated', submeterAllocated !== null && submeterAllocated !== void 0 ? submeterAllocated : allocated, '698-2-new-billing-module'), getButton('Bill', billAmount, '698-3-new-billing-module'), getButton('Deductions', deductions, '698-4-new-billing-module'), /*#__PURE__*/React.createElement("div", null, billStatus === 'TableSkipped' ? /*#__PURE__*/React.createElement(Button, {
    'custom-attribute': '695-new-billing-module',
    onClick: handleEdit,
    size: isCurrent ? 'medium' : 'small',
    variant: isCurrent ? 'actionIcon' : 'contained'
  }, isCurrent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), "Edit") : isBySubmeter && utility.submeterFinalState !== null && Array.isArray(utility.submeterFinalState) && utility.submeterFinalState.length > 0 ? getStatus() : 'View reason') : /*#__PURE__*/React.createElement(Button, {
    onClick: handleProcess,
    size: "small",
    variant: "contained",
    'custom-attribute': '590-new-billing-module'
  }, isPending && !(isBySubmeter && utility.submeterFinalState !== null && Array.isArray(utility.submeterFinalState) && utility.submeterFinalState.length > 0) ? 'Process' : getStatus())), isCurrent && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '591-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, isCurrent ? /*#__PURE__*/React.createElement(Button, {
    disabled: !utility.isEditable,
    onClick: handleSkip,
    variant: "menuAction",
    'custom-attribute': '593-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin-copper"
  }), isSkipped ? 'Unskip' : 'Skip', " this bill") : null, isCurrent && !isAdditional ? /*#__PURE__*/React.createElement(Button, {
    onClick: handleDelete,
    variant: "menuAction",
    'custom-attribute': '597-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin-copper"
  }), "Delete") : null)))));
};
export default Utility;